export const isValidId = (id?: unknown): id is number => {
  return typeof id === "number" && !isNaN(id) && id > 0;
};

export const createRandomId = (): number => {
  return Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
};
